type PressLogo = {
  src: string;
  alt: string;
  className: string;
  href?: string;
};

const logos: PressLogo[] = [
  { src: '/img/press/menshealth.png', alt: "Men's Health", className: 'h-6' },
  { src: '/img/press/psychologytoday.png', alt: 'Psychology Today', className: 'h-6' },
  { src: '/img/press/yourtango.png', alt: 'YourTango', className: 'h-6' },
  { src: '/img/press/refinery29.png', alt: 'Refinery29', className: 'h-6' },
];

export default function FeaturedIn() {
  return (
    <section className="pt-10 pb-16">
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/20 text-center mb-8">
        As featured in
      </p>

      <div className="flex justify-center items-center gap-4 sm:gap-8 px-8">
        {logos.map((logo) => {
          const img = (
            <img
              src={logo.src}
              alt={logo.alt}
              className={`${logo.className} max-w-[80px] sm:max-w-none w-auto object-contain brightness-0 invert opacity-60 transition-opacity duration-500 hover:opacity-100`}
            />
          );

          return logo.href ? (
            <a
              key={logo.alt}
              href={logo.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Read the ${logo.alt} feature about OurSexQuiz`}
              className="inline-block"
            >
              {img}
            </a>
          ) : (
            <span key={logo.alt} className="inline-block">
              {img}
            </span>
          );
        })}
      </div>
    </section>
  );
}
